import { render, staticRenderFns } from "./AwardCoins.vue?vue&type=template&id=59f75947&scoped=true&"
import script from "./AwardCoins.vue?vue&type=script&lang=ts&"
export * from "./AwardCoins.vue?vue&type=script&lang=ts&"
import style0 from "./AwardCoins.vue?vue&type=style&index=0&id=59f75947&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f75947",
  null
  
)

export default component.exports